import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';

import {FuseTranslationLoaderService} from '@fuse/services/translation-loader.service';
import {locale as english} from 'app/common/import-csv-result-modal/i18n/en';
import {locale as french} from 'app/common/import-csv-result-modal/i18n/fr';
import {ImportResult} from 'app/main/private/setup/import-data/model/import-result.model';
import {NZ_MODAL_DATA} from 'ng-zorro-antd/modal';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-import-csv-result-modal',
    templateUrl: './import-csv-result-modal.component.html',
    styleUrls: ['./import-csv-result-modal.component.scss'],
    standalone: false
})
export class ImportCsvResultModalComponent {
    importResult: ImportResult;

    constructor(
        @Inject(NZ_MODAL_DATA) public modalData: any,
        private translationLoader: FuseTranslationLoaderService
    ) {
        this.importResult = modalData.importResult;
        this.translationLoader.loadTranslations(english, french);
    }
}
